export enum enmFactSheetFileType {
  Logo = "logo",
  ConfirmStamp = "confirmstamp",
  UnConfirmStamp = "unconfirmstamp",
}
